<template>
  <v-container fluid>
    <v-layout child-flex>
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="activeTransactions"
          :pagination.sync="pagination"
          :rows-per-page-items="pageCountOptions"
          item-key="authorized"
          class="elevation-0 installments"
          expand
          no-data-text="No data found"
          no-results-text="No results found"
          must-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.value"
                :class="['font-weight-bold text-xs-center column sortable pa-0', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
                v-if="header.value !== 'card_expiration_yymm' || (header.value === 'card_expiration_yymm' && (transaction.request_type !== 'ach' && transaction.request_type !== 'achcredit'))"
              >
              <div class="pl-3" v-if="header.sortable">
                {{ header.text }}
                <v-icon small pa-0>arrow_upward</v-icon>
              </div>
              <div v-else>
                {{ header.text }}
              </div>
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr class="hover-table">
              <td class="text-xs-center">{{ dateUtc(props.item.authorized) }}</td>
              <td class="text-xs-center">
                <span v-if="props.item.tracking_id">{{ props.item.tracking_id || '-' }}</span>
                <span class="text--disabled" v-else>-</span>
              </td>
              <td class="text-xs-center">
                <div v-if="props.item.request_type === 'achcredit' || props.item.request_type === 'credit'">
                  <v-chip small outline color="black">Refund
                    <Lightbulb>
                      <template v-slot:message>
                        <span>Refunds Transaction Id: {{ getAffectedTransactionId(props.item.parent_transaction_id) }}</span>
                      </template>
                    </Lightbulb>
                  </v-chip>
                </div>
                <v-chip small outline color="black" v-else-if="props.item.request_type === 'ach' || props.item.request_type === 'sale'">Sale</v-chip>
                <v-chip small outline v-else-if="props.item.is_pending_recurring">Pending Sale</v-chip>
                <v-chip small outline color="black" v-else-if= "props.item.request_type === 'modify'">Modify</v-chip>
                <div v-else-if="props.item.request_type === 'achvoid'|| props.item.request_type === 'void'">
                  <v-chip small outline color="black">Void
                    <Lightbulb>
                      <template v-slot:message>
                        <span>Voids Transaction Id: {{ getAffectedTransactionId(props.item.parent_transaction_id) }}</span>
                      </template>
                    </Lightbulb>
                  </v-chip>
                </div>
                <div v-else>-</div>
              </td>
              <td class="text-xs-center">{{ money((props.item.modify_total_amount ? props.item.modify_total_amount : props.item.total_amount) / 100) }}</td>
              <td class="text-capitalize text-xs-center">
                <v-chip small outline color="black" v-if="props.item.voided">Voided
                  <Lightbulb>
                    <template v-slot:message>
                      <span>Voided By Transaction Id: {{ getAffectedTransactionId(props.item.voided_transaction_id) }}</span>
                    </template>
                  </Lightbulb>
                </v-chip>
                <v-chip small outline color="black" v-else-if="props.item.refunded">Refunded
                  <Lightbulb>
                    <template v-slot:message>
                      <span>Refunded By Transaction Id: {{ getAffectedTransactionId(props.item.refunded_transaction_id) }}</span>
                    </template>
                  </Lightbulb>
                </v-chip>
                <v-chip small outline color="disabled" v-else-if="!props.item.settled && props.item.response_code === '000' && props.item.response_text === 'PENDING'">Pending</v-chip>
                <v-chip small outline color="black" v-else-if="!props.item.settled && props.item.response_code === '000'">Approved</v-chip>
                <v-chip small outline color="black" v-else-if="props.item.settled && props.item.response_code === '000'">Settled</v-chip>
                <v-chip small outline color="black" v-else>Declined</v-chip>
              </td>
              <td class="text-xs-center">{{ dateUtc(props.item.settled) || '-' }}</td>
              <td class="text-xs-center">
                <span v-if="props.item.user_id"><v-chip small outline><v-icon small class="mr-1">person</v-icon>Manual</v-chip></span>
                <span v-else><v-chip small outline><v-icon small class="mr-1">computer</v-icon>System</v-chip></span>
              </td>
              <td class="text-xs-center">{{ props.item.last_four || '-' }}</td>
              <td class="text-xs-center" v-if="(transaction.request_type !== 'ach' && transaction.request_type !== 'achcredit')">
                <div>
                  {{ props.item.card_expiration_yymm ? props.item.card_expiration_yymm : '-' }}
                </div>
              </td>
              <td class="text-xs-center">
                <template v-if="!props.item.hasOwnProperty('is_pending_recurring') || !props.item.is_pending_recurring">
                  <ReceiptModal :transaction="props.item" />
                </template>
                <template v-else>-</template>
              </td>
              <td class="text-xs-center">
                <div class="px-1">
                <template v-if="(!props.item.hasOwnProperty('is_pending_recurring') || !props.item.is_pending_recurring) && (!(props.item.request_type === 'achvoid' || props.item.request_type === 'void' || props.item.request_type === 'achcredit' || props.item.request_type === 'credit' || props.item.request_type === 'modify'))">
                  <VoidModal :transaction="props.item" v-if="!props.item.settled && !props.item.voided && props.item.response_code === '000'" />
                  <RefundModal :transaction="props.item" v-if="props.item.settled && !props.item.refunded && !props.item.voided && props.item.response_code === '000'" />
                  <span class="text--disabled" v-if="props.item.voided || props.item.refunded">N/A</span>
                </template>
                <template v-else>
                  <span class="text--disabled">N/A</span>
                </template>
                </div>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            No data found
          </template>

          <template slot="actions-prepend">
            <v-radio-group class="justify-start" v-model="settledOnly" row hide-details label="Filter Transactions: ">
              <v-radio
                color="black"
                key="salesTransactions"
                label="Show Settled"
                :value="true"
                hide-details
              />
              <v-radio
                color="black"
                key="allTransactions"
                label="Show All"
                :value="false"
                hide-details
              />
            </v-radio-group>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

import ReceiptModal from '@/components/transactions/ReceiptModal.vue'
import RefundModal from '@/components/transactions/RefundModal.vue'
import VoidModal from '@/components/transactions/VoidModal.vue'
import Lightbulb from '@/components/help/Lightbulb'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, RecurringMixin, StoreMixin, UtilityMixin],
  components: {ReceiptModal, RefundModal, VoidModal, Lightbulb},

  data: function () {
    return {
      enabled: false,
      settledOnly: false,
      headers: [
        {
          value: 'authorized',
          text: 'Date',
          sortable: true,
          align: 'center'
        },
        {
          value: 'tracking_id',
          text: 'Transaction ID',
          sortable: true,
          align: 'center'
        },
        {
          value: 'transaction_type',
          text: 'Type',
          sortable: true,
          align: 'center'
        },
        {
          value: 'total_amount',
          text: 'Amount',
          sortable: true,
          align: 'center'
        },
        {
          value: 'transaction_status',
          text: 'Status',
          sortable: true,
          align: 'center'
        },
        {
          value: 'settled',
          text: 'Settled',
          sortable: true,
          align: 'center'
        },
        {
          value: 'user_id',
          text: 'Initiation',
          sortable: true,
          align: 'center'
        },
        {
          value: 'last_four',
          text: 'Last Four',
          sortable: true,
          align: 'center'
        },
        {
          value: 'card_expiration_yymm',
          text: 'Expiration',
          sortable: true,
          align: 'center'
        },
        {
          value: 'receipt',
          text: 'Receipt',
          align: 'center',
          sortable: false
        },
        {
          value: 'actions',
          text: 'Actions',
          align: 'center',
          sortable: false
        }
      ],
      pagination: {
        sortBy: 'authorized',
        descending: false,
        page: 1,
        rowsPerPage: 12,
        totalItems: this.activeTransactionsLength
      },
      pageCountOptions: [12, 24, 48, {text: 'All', value: -1}],
      loading: false
    }
  },

  props: {
    terminal: Object,
    transaction: Object,
    transactions: Array
  },

  beforeDestroy () {
    Bus.$off('closeOptionsModal')
  },

  mounted () {
    Bus.$on('closeOptionsModal', this.reloadPlan)

    this.load()
  },

  computed: {
    activeTransactions: function () {
      if (this.transactions) {
        let trans = []
        let associatedTransactions = []
        const expectedTransactionTypes = ['sale', 'credit', 'ach', 'achcredit']
        const uniqueTransactions = new Set()

        const addUniqueTrans = (transaction) => {
          let uniqueKey
          if (transaction.id) {
            uniqueKey = transaction.id
          } else if (transaction.is_pending_recurring) {
            uniqueKey = `future_${transaction.parent_id}_${transaction.authorized}`
          } else {
            uniqueKey = `${transaction.authorized}_${transaction.total_amount}`
          }

          if (!uniqueTransactions.has(uniqueKey)) {
            uniqueTransactions.add(uniqueKey)
            trans.push(transaction)
          }
        }

        this.transactions.forEach(tran => {
          if ((!expectedTransactionTypes.includes(tran.request_type))) {
            return
          }

          if (tran.hasOwnProperty('associatedTransactions') && tran.associatedTransactions.length) {
            tran.associatedTransactions.forEach(associated => {
              if (associated.authorized || (expectedTransactionTypes.includes(associated.request_type))) {
                addUniqueTrans(associated)
              }
            })
          }

          if (tran.is_recurring) {
            if (!tran.parent_transaction_id) {
              if (!tran.authorized) {
                addUniqueTrans(Object.assign({}, tran, { authorized: tran.modify_recurring_start ? tran.modify_recurring_start : tran.recurring_start }))
              } else if (tran.settled) {
                addUniqueTrans(Object.assign({}, tran, { authorized: tran.settled }))
              } else if (Moment((tran.modify_recurring_start ? tran.modify_recurring_start : tran.recurring_start)).isAfter(tran.authorized)) {
                addUniqueTrans(Object.assign({}, tran, { authorized: tran.modify_recurring_start ? tran.modify_recurring_start : tran.recurring_start }))
              } else {
                addUniqueTrans(tran)
              }
            }

            if (tran.voided) {
              return
            }

            associatedTransactions = this.getInstallments(tran)
            if (!tran.settled || !Moment(tran.modify_recurring_start ? tran.modify_recurring_start : tran.recurring_start).isAfter(tran.settled)) {
              associatedTransactions.shift()
            }
            let cardDeclined = (tran.payment_type !== 'ach' && tran.response_code !== '000')

            if (this.transaction.recurring_status !== 'cancelled' && this.transaction.recurring_status !== 'ended') {
              associatedTransactions.forEach((associated) => {
                if (Moment.utc().isAfter(associated) || tran.associatedTransactions.some(child => Moment(child.authorized).format('YYYY-MM-DD') === associated.format('YYYY-MM-DD'))) {
                  return
                }
                addUniqueTrans({
                  parent_id: tran.id, // Add parent ID for reference
                  authorized: associated.format('YYYY-MM-DDTHH:mm:ssZ'),
                  is_pending_recurring: true,
                  total_amount: tran.modify_total_amount ? tran.modify_total_amount : tran.total_amount,
                  tracking_id: '',
                  transaction_status: cardDeclined ? 'Stopped' : 'Pending',
                  response_code: '000',
                  response_text: cardDeclined ? 'STOPPED' : 'PENDING',
                  voided: null,
                  settled: null,
                  refunded: null
                })
              })
            }
          } else if (tran.future_post) {
            addUniqueTrans(Object.assign({}, tran, { authorized: tran.future_post, is_pending_recurring: true }))
          } else if (!tran.is_recurring) {
            addUniqueTrans(tran)
          }
        })
        const filteredTransactions = this.filterSettledOnlyTransactions(trans)
        return this.sortTransactions(filteredTransactions)
      }

      return []
    },

    activeTransactionsLength: function () {
      return this.activeTransactions.length
    },

    associatedSorted: function () {
      return [...this.transaction.associatedTransactions].reverse()
    },

    scheduledTransactions: function () {
      return this.getInstallments(this.transaction)
    }
  },

  methods: {
    async load () {},

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    filterSettledOnlyTransactions (trans) {
      if (this.settledOnly) {
        return trans.filter(t => (t.request_type === 'sale' || t.request_type === 'ach') && t.settled)
      }
      return trans // Return the original array if settledOnly is false
    },
    sortTransactions (trans) {
      if (this.pagination.sortBy === 'authorized') {
        if (this.pagination.descending) {
          trans.sort((a, b) => (Moment(a.authorized).isBefore(b.authorized)) ? 1 : -1)
        } else {
          trans.sort((a, b) => (Moment(a.authorized).isAfter(b.authorized)) ? 1 : -1)
        }
      } else {
        if (this.pagination.descending) {
          trans.sort((a, b) => (a[this.pagination.sortBy] < b[this.pagination.sortBy] ? -1 : 1))
        } else {
          trans.sort((a, b) => (a[this.pagination.sortBy] > b[this.pagination.sortBy] ? -1 : 1))
        }
      }
      return trans
    },

    reloadPlan () {
      Bus.$emit('reloadPlan')
    },

    getAffectedTransactionId (id) {
      let affectedTransaction = this.transactions.find(transaction => transaction.id === id)
      return affectedTransaction.tracking_id
    }
  }
}
</script>

<style lang="less">
  .installments table.v-table tbody {
    outline: 1px solid var(--v-primary-base);
  }

  .installments table.v-table td {
    background-color: #f4f4f4;
    outline: 2px solid white;
    padding: 0 !important;
  }

  .installments .v-datatable__actions {
    border-top: 1px solid var(--v-primary-base) !important;
    margin-top: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/plans/Schedule.vue